/**
 * Faro の初期化（docs/spec/observability.md §4）。
 */
import { getWebInstrumentations, initializeFaro, type Faro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

export const SERVICE_NAME = 'inductor-class-frontend';

export interface FaroStartOptions {
  origin: string;
  version: string;
  environment: string;
}

/** collector の絶対 URL（C9: ignoreUrls の文字列は完全一致なので相対にしない）。 */
export function collectorUrl(origin: string): string {
  return new URL('/faro/collect', origin).href;
}

export function startFaro(opts: FaroStartOptions): Faro {
  return initializeFaro({
    url: collectorUrl(opts.origin),
    app: {
      name: SERVICE_NAME,
      version: opts.version,
      environment: opts.environment,
    },
    ignoreUrls: [/\/faro\/collect$/],
    sessionTracking: {
      enabled: true,
      // タブを閉じたら新しいセッションにし、日をまたいで同じ人を追わない。
      persistent: false,
      samplingRate: 1,
    },
    instrumentations: [
      // console は送らない。学習者のコードや出力が console に出ることがある。
      ...getWebInstrumentations({ captureConsole: false }),
      new TracingInstrumentation({
        // C6: 未サンプルのセッションは traceparent（-00）を送らない。
        omitTraceContextForUnsampledSessions: true,
        // 同一オリジンだけに traceparent を付ける（propagateTraceHeaderCorsUrls は指定しない）。
      }),
    ],
  });
}
